<template>
<Dialog v-model:visible="show" modal header="Markaya Özel Sütunlar" :style="{ width: '75vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<ScrollPanel style="width: 100%; height: 400px" v-if="!loading">



<ClickAddInputText  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="new_phrase" @newAdded="newAdded"></ClickAddInputText>
<hr>

<div class="grid" v-for="item in columns" >
<div class="col-10">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" valkey="name" @dataChanged="dataChanged($event,item.id)" />


<ClickEditSwitch  title="Marka ile paylaş" :value="item.share_with_brand" valkey="share_with_brand" @dataChanged="dataChanged($event,item.id)" />

</div>

<div class="col-2">
<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm mt-3" @click="deleteItem('brand_planner_column',item.id)"></Button>

</div>


</div>


</ScrollPanel>



</Dialog>


</template>
<script>
export default {

  name: 'PlannerSpecificFiltersDialog',
  props:["open","brand_id","type"],
  data () {
    return {
    	show:false,
    	loading:true,
    	columns:[],
    }
  },
  computed:{
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	},
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
  			this.afternewAdded()
  		}
  	},
  },
  methods:{
  	openDialog()
  	{
  		this.show = true
  		this.getData()
  	},
  	async getData()
  	{
  		this.loading = true
  		this.columns = await this.generalApiGetWithoutLoader("brand_planner_columns/"+this.brand_id+"/"+this.type)
  		console.log(this.columns)
  		this.loading = false
  	},
  	newAdded(data)
  	{
  	  let formdata = new FormData()
      formdata.append("name",data.value)
      formdata.append("type",this.type)    
      this.generalSubmission(formdata,"submit_brand_planner_column/"+this.brand_id,this.afternewAdded)
  	},
  	async afternewAdded(response)
  	{
  		this.columns = await this.generalApiGetWithoutLoader("brand_planner_columns/"+this.brand_id+"/"+this.type)
  		this.$emit("renewData")
  	},
  	dataChanged(data,id)
  	{      
  		let formdata = new FormData()
  		formdata.append(data.key,data.value)
  		this.generalSubmission(formdata,"update_brand_planner_column/"+id,this.afternewAdded)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>